import { render } from "./ArchivalView.vue?vue&type=template&id=fe4f5766&scoped=true"
import script from "./ArchivalView.vue?vue&type=script&lang=js"
export * from "./ArchivalView.vue?vue&type=script&lang=js"

import "./ArchivalView.vue?vue&type=style&index=0&id=fe4f5766&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe4f5766"]])

export default __exports__